import search from './search/texts.js';

export default {
  search,
  article: {
    accordion: {
      title: {
        notes: 'Title of accordion header',
        message: 'Articles',
      },
    },
    model: {
      position: {
        notes: 'Title of position column header in articles accordion',
        message: 'Position',
      },
      name: {
        notes: 'Title of name column header in articles accordion',
        message: 'Name',
      },
      orderedStatus: {
        notes: 'Title of ordered status column header in articles accordion',
        message: 'Ordered',
        values: {
          open: {
            notes: 'Status "Open" for an article',
            message: 'Open',
          },
          ordered: {
            notes: 'Status "Ordered" for an article',
            message: 'Ordered',
          },
        },
      },
      articleId: {
        notes: 'Title of article id column header in articles accordion',
        message: 'Article ID',
      },
      weight: {
        notes: 'Title of weight column header in articles accordion',
        message: 'Weight',
      },
      quantity: {
        notes: 'Title of quantity column header in articles accordion',
        message: 'Qty',
      },
    },
    empty: {
      text: {
        notes: 'Text of empty state when no articles exist',
        message:
          'No articles added yet. Use the search field above to find and add articles!',
      },
    },
  },
};
